import { UI_IDS } from './config.js';

export class MapUI {
    constructor(mapComponent) {
        this.app = mapComponent;
    }

    injectHTML() {
        // Create the Modal Container
        if (!document.getElementById(UI_IDS.modalId)) {
            const modal = document.createElement('div');
            modal.id = UI_IDS.modalId;
            modal.className = 'map-modal hidden';
            modal.innerHTML = `
                <div class="map-modal-content">
                    <button id="close-map-btn" class="close-btn">${this.app.t.closeMap}</button>
                    <div id="${UI_IDS.mapContainerId}"></div>
                    <div id="${UI_IDS.uiContainerId}"></div>
                </div>
            `;
            document.body.appendChild(modal);

            document.getElementById('close-map-btn').addEventListener('click', () => {
                modal.classList.add('hidden');
                
                // Update Glassmorphism Dock state if it exists
                if (window.mainUI) {
                    window.mainUI.isMapActive = false;
                    const dockMapBtn = document.getElementById('btn-open-map');
                    if (dockMapBtn) {
                        dockMapBtn.classList.remove('active');
                    }
                }
            });
        }
    }

    buildUI() {
        const container = document.getElementById(UI_IDS.uiContainerId);
        if (!container) return;

        let uiHtml = `
            <div class="wheelmap-header" id="wheelmap-toggle-header">
                <h3>${this.app.t.accessibilityLayers}</h3>
                <span id="wheelmap-toggle-icon">▼</span>
            </div>
            <div class="filters-grid collapsed" id="wheelmap-filters-grid">`;
        
        const defaultActiveLayers = ['paths', 'poi_elevators', 'poi_ramps', 'poi_parking', 'poi_entrances', 'poi_wc'];

        for (const layerKey of Object.keys(this.app.arcGisLayers)) {
            if (layerKey === 'plots') continue;

            const rawKey = layerKey.replace('poi_', '');
            let label = rawKey.replace(/^\w/, c => c.toUpperCase());
            if (this.app.t.layers && this.app.t.layers[rawKey]) {
                label = this.app.t.layers[rawKey];
            }
            
            const isChecked = defaultActiveLayers.includes(layerKey) ? 'checked' : '';
            
            uiHtml += `
                <label class="filter-option">
                    <input type="checkbox" data-layer="${layerKey}" class="layer-toggle" ${isChecked}>
                    <span class="custom-checkbox"></span>
                    ${label}
                </label>
            `;
            
            if (isChecked && this.app.map) {
                this.app.map.addLayer(this.app.arcGisLayers[layerKey]);
            }
        }

        uiHtml += `</div>`;
        container.innerHTML = uiHtml;

        const toggleHeader = document.getElementById('wheelmap-toggle-header');
        const filtersGrid = document.getElementById('wheelmap-filters-grid');
        const toggleIcon = document.getElementById('wheelmap-toggle-icon');
        
        if (toggleHeader && filtersGrid) {
            toggleHeader.addEventListener('click', () => {
                const isCollapsed = filtersGrid.classList.toggle('collapsed');
                toggleIcon.textContent = isCollapsed ? '▼' : '▲';
            });
        }

        const checkboxes = container.querySelectorAll('.layer-toggle');
        checkboxes.forEach(cb => {
            cb.addEventListener('change', (e) => {
                if(!this.app.map) return;
                const layer = this.app.arcGisLayers[e.target.dataset.layer];
                if (e.target.checked) {
                    this.app.map.addLayer(layer);
                } else {
                    this.app.map.removeLayer(layer);
                }
            });
        });
    }

    updateUITexts() {
        const openBtn = document.getElementById('open-map-btn');
        if (openBtn) openBtn.innerHTML = `🗺️ ${this.app.t.openMap}`;

        const closeBtn = document.getElementById('close-map-btn');
        if (closeBtn) closeBtn.innerHTML = this.app.t.closeMap;

        const header = document.querySelector('#wheelmap-toggle-header h3');
        if (header) header.innerHTML = this.app.t.accessibilityLayers;

        const container = document.getElementById(UI_IDS.uiContainerId);
        if (container) {
            const labels = container.querySelectorAll('.filter-option');
            labels.forEach(labelEl => {
                const input = labelEl.querySelector('input.layer-toggle');
                if (input) {
                    const layerKey = input.dataset.layer;
                    const rawKey = layerKey.replace('poi_', '');
                    
                    let text = rawKey.replace(/^\w/, c => c.toUpperCase());
                    if (this.app.t.layers && this.app.t.layers[rawKey]) {
                        text = this.app.t.layers[rawKey];
                    }
                    
                    // Target the text node safely without overriding the whole HTML inner content (checkbox elements)
                    const textNode = Array.from(labelEl.childNodes).find(n => n.nodeType === Node.TEXT_NODE && n.nodeValue.trim().length > 0);
                    if (textNode) {
                        textNode.nodeValue = ` ${text}`;
                    }
                }
            });
        }
    }
}